import { render, staticRenderFns } from "./UpgradeContent.vue?vue&type=template&id=7c2915d6"
import script from "./UpgradeContent.vue?vue&type=script&lang=js"
export * from "./UpgradeContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports